/* eslint-disable @typescript-eslint/no-unused-vars */
import { Select, MenuItem, FormControl, Typography, TextField, SelectProps, Box } from '@mui/material';
import styled from 'styled-components';


export const StyledSelect = styled(Select)<SelectProps>(({ theme }) => ({
  backgroundColor: theme.palette.base.background,
  borderColor: theme.palette.primary[300],
  svg: {
    color: theme.palette.grey[500],
    stroke: theme.palette.grey[500],
    height: '20px',
    width: '20px',
    right: '12px',
    top: '28%',
  },
  '.MuiInputBase-input': {
    padding: '10px 14px',
    fontSize: theme.typography.tmd.fontSize,
    lineHeight: '24px',
    fontWeight: '400',
    borderRadius: '8px',
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.base.background,
  borderColor: theme.palette.primary.main,
  svg: {
    color: theme.palette.grey[300],
    fontSize: '20px',
  },
  ':hover': {
    backgroundColor: theme.palette.primary[100],
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary[100],
  },
  textTransform: 'capitalize',
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '.MuiInput-outlined': {
    border: `solid 1px ${theme.palette.grey[300]}`,
    borderBottom: 'unset',
    borderRadius: '8px',
  },
  '& fieldset': {
    borderRadius: '6px',
  },
}));

export const StyledLabel = styled(Typography).attrs({ component: 'div' as const })(({ theme }) => ({
  fontSize: theme.typography.tsm.fontSize,
  color: theme.palette.text.primary,
  marginBottom: '6px',
  lineHeight: '20px',
  fontWeight: '500',
  display: 'flex',
  alignItems: 'center',
}));

export const Input = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.base.background,
  borderColor: theme.palette.grey[300],
  borderRadius: '8px',
  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
  '.MuiInputBase-input': {
    backgroundColor: theme.palette.base.background,
    borderColor: theme.palette.grey[300],
    padding: '10px 14px',
    borderRadius: '8px',
    '::placeholder': {
      color: theme.palette.grey[500],
      opacity: '1',
      fontWeight: '400',
    },
  },
  '.MuiInputBase-adornedStart': {
    '.MuiInputBase-input': {
      paddingLeft: '0px',
    },
  },
  textarea: {
    padding: '0!important',
  },
}));


export const StyledDatePicker = styled(Box)(({ theme }) => ({
  '.react-datepicker': {
    border: 'none',
    backgroundColor: theme.palette.base.background,
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__navigation-icon': {
    ':before': {
      borderColor: `${theme.palette.grey[100]}!important`,
      borderWidth: '2px 2px 0 0',
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__month-container': {
    backgroundColor: theme.palette.base.background,
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__time-container ': {
    border: 'none',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__time-list': {
    backgroundColor: theme.palette.base.background,
    color: theme.palette.text.primary,
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__current-month': {
    fontWeight: 'normal',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__day': {
    color: theme.palette.text.primary,
    ':hover': {
      backgroundColor: `${theme.palette.primary[100]}!important`,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__day-names': {
    marginTop: 10,
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__day--selected': {
    ':hover': {
      backgroundColor: `${theme.palette.primary[100]}!important`,
      color: theme.palette.grey[900],
    },
    color: theme.palette.grey[100],
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__time-list-item': {
    ':hover': {
      backgroundColor: `${theme.palette.primary[100]}!important`,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__time-list-item--selected': {
    ':hover': {
      backgroundColor: `${theme.palette.primary[100]}!important`,
      color: `${theme.palette.grey[900]}!important`,
    },
    color: theme.palette.grey[100],
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker-time__header': {
    fontWeight: 'normal',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__triangle': {
    ':before': {
      borderBottomColor: `${theme.palette.grey[400]}!important`,
    },
    ':after': {
      borderBottomColor: `${theme.palette.primary[400]}!important`,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__header': {
    backgroundColor: theme.palette.primary[400],
    borderColor: theme.palette.grey[300],
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__day--keyboard-selected': {
    backgroundColor: theme.palette.primary[600],
    color: theme.palette.grey[100],
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker__input-time-container': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '15px',
    padding: '15px',
    float: 'unset',
    margin: '0',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker-time__input': {
    width: '100%!important',
    margin: '0!important',
    borderColor: `${theme.palette.grey[300]}!important`,
    backgroundColor: 'transparent!important',
    borderWidth: '1px!important',
    borderRadius: '4px!important',
    borderStyle: 'solid!important',
    color: theme.palette.grey[900],
    input: {
      padding: '5px',
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker-time__caption': {
    color: theme.palette.grey[900],
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '.react-datepicker-time__input-container': {
    width: '100%!important',
  },
  svg: {
    height: '20px',
    width: '20px',
  },
}));

export const StyledTooltipIndicator = styled.div(({ theme }) => ({
  color: theme.palette.primary[600],
  width: '16px',
  borderRadius: '50%',
  fontSize: '8px',
  textAlign: 'center',
  height: '16px',
  display: 'inline-block',
  marginLeft: '4px',
  cursor: 'pointer',
  border: `solid 1px ${theme.palette.primary[600]}`,
  lineHeight: '16px',
  fontWeight: 'bold',
  ':hover': {
    background: theme.palette.primary[600],
    color: theme.palette.grey[25],
  },
}));
